import { columnHelper } from './helper';

export const taskName = columnHelper.accessor('TaskName', {
  header: 'Task Name',
  id: 'taskName',
});
